import { useEffect } from 'react';

import { useAppTheme, useThemeHelpers } from './useAppTheme.js';

/**
 * Big-top shell helpers for standalone app pages (course home, teacher tools, etc.).
 *
 * @param {string} pageKey — key in themeRegistry `pageClasses`
 */
export function useAppPageTheme(pageKey) {
  const theme = useAppTheme();
  const helpers = useThemeHelpers(theme);
  const pageThemeClass = helpers.pageClass(pageKey);
  const isThemed = helpers.isThemed && Boolean(pageThemeClass);
  const shellClass = pageThemeClass ? `app-page ${pageThemeClass}` : undefined;
  const legacyStyle = (style) => (isThemed ? undefined : style);

  useEffect(() => {
    if (!isThemed || !helpers.appContentClass) {
      return undefined;
    }

    const appContent = document.querySelector('.appContent');
    appContent?.classList.add(helpers.appContentClass);

    return () => {
      appContent?.classList.remove(helpers.appContentClass);
    };
  }, [isThemed, helpers.appContentClass]);

  return {
    ...helpers,
    isThemed,
    shellClass,
    pageThemeClass,
    legacyStyle,
  };
}
